// Template API Service - Backend Integration
import { apiGet, apiPost, apiDelete } from '../services/apiClient';

// Helper to wrap response in { data: ... } format for backward compatibility
const wrapResponse = (data) => ({ data });

/**
 * Create or update template for a category
 * POST /gateway/api/ticket/templates
 */
export const createOrUpdateTemplate = async (templateData) => {
  const endpoint = '/gateway/api/ticket/templates';
  
  try {
    const response = await apiPost(endpoint, templateData);
    return wrapResponse(response);
  } catch (error) {
    console.error('Failed to create/update template:', error);
    throw error;
  }
};

/**
 * Get template (fields) for a specific category
 * GET /gateway/api/ticket/templates/category/{categoryId}
 */
export const getTemplateByCategory = async (categoryId, options = {}) => {
  const includeInactive = options.includeInactive === true;
  const qs = includeInactive ? '?includeInactive=true' : '';
  const endpoint = `/gateway/api/ticket/templates/category/${categoryId}${qs}`;

  try {
    const response = await apiGet(endpoint);
    return wrapResponse(response);
  } catch (error) {
    console.error('Failed to fetch template by category:', error);
    throw error;
  }
};

/**
 * Get active template for category
 * GET /gateway/api/ticket/templates/active?categoryId={categoryId}
 */
export const getActiveTemplate = async (categoryId) => {
  const endpoint = `/gateway/api/ticket/templates/active?categoryId=${categoryId}`;
  
  try {
    const response = await apiGet(endpoint);
    return wrapResponse(response);
  } catch (error) {
    console.error('Failed to fetch active template:', error);
    throw error;
  }
};

/**
 * Get all templates
 * GET /gateway/api/ticket/templates
 */
export const getAllTemplates = async () => {
  const endpoint = '/gateway/api/ticket/templates';
  
  try {
    const response = await apiGet(endpoint);
    return wrapResponse(response);
  } catch (error) {
    console.error('Failed to fetch all templates:', error);
    throw error;
  }
};

/**
 * Delete template for a category
 * DELETE /gateway/api/ticket/templates/category/{categoryId}
 */
export const deleteTemplate = async (categoryId) => {
  const endpoint = `/gateway/api/ticket/templates/category/${categoryId}`;
  
  try {
    const response = await apiDelete(endpoint);
    return wrapResponse(response);
  } catch (error) {
    console.error('Failed to delete template:', error);
    throw error;
  }
};

// Service object for backward compatibility
export const templateService = {
  createOrUpdateTemplate,
  getTemplateByCategory,
  getActiveTemplate,
  getAllTemplates,
  deleteTemplate,
};

export default templateService;

